<!-- footer.vue -->
<template>
	<div
		class="ui-detail-footer"
		v-if="detailInfo"
		v-bind:class="{
			'hidden-cart-footer': ispromotion,
			'show-cart-footer': !ispromotion
		}"
	>
		<div class="footer-flex">
			<div class="left">
				<!-- <span class="iconfont" v-on:click="goCart()">&#xe6ae;</span> -->
				<!-- <span class="iconfont">&#xe6ae;</span> -->
				<div class="cartBox">
					<img src="@/assets/image/home/cart.svg" style="width: 95%;" />
				</div>
				<span class="icon" v-if="cartNumber > 0">{{ cartNumber }}</span>
			</div>
			<div class="right">
				<div class="right-wrapper">
				<div
						class="button "
						:class="canBuy?'active-cart':'disabled-cart'"
						v-on:click="addShopping(true)"
				>
					{{addCartText}}
				</div>
				<!-- <div
						class="button "
						:class="canBuy?'active-buy':'disabled-buy'"
						v-on:click="checkout()"
				>
					{{buyNowText}}
				</div> -->
				</div>
			</div>
		</div>

		<p class="good-stock-none" v-if="detailInfo.goods_state != 1 || detailInfo.goods_verify!=1">
			{{ $t('store.alerts.no_longer_be_sold') }}
		</p>
		<p class="good-stock-none" v-else-if="detailInfo.goods_storage <= 0">
			{{ $t('store.alerts.out_of_stock') }}
		</p>

		<shopping v-if="isShowcartInfo" :isShowcartInfo="isShowcartInfo"></shopping>

		<!-- 加入购物车显示动画 -->
		<div class="ui-cart-animation" v-if="isAnimation">
			<mt-spinner type="snake" color="#FA800A"></mt-spinner>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast,MessageBox } from 'mint-ui'
import shopping from './child/Shopping'
import { cartQuantity } from '../../../api/homecart'
export default {
  data () {
    return {
		addCartText: this.$t('store.add_to_cart'),
		buyNowText: this.$t('store.buy_now'),
      isAnimation: false // 加入购物车成功之后是否显示动画
    }
  },

	components: {
		shopping
	},

	props: {
		ishidefooter: {
			type: Boolean,
			default: false
		}
	},

  computed: {
    ...mapState({
		config: state => state.config.config,
		user: state => state.member.info,
      // 是否显示购物车浮层
      isShowcartInfo: state => state.goodsdetail.isShowcartInfo,
		storeInfo: state => state.goodsdetail.storeInfo,
      detailInfo: state => state.goodsdetail.detailInfo,
		specList: state => state.goodsdetail.specList,
      isOnline: state => state.member.isOnline,
      ispromotion: state => state.goodsdetail.ispromotion,
      // cartNumber: state => state.tabBar.cartNumber,
      chooseinfo: state => state.goodsdetail.chooseinfo,
      number: state => state.goodsdetail.number,
      shopCart: state => state.goodsdetail.shopCart,
    }),
	  canBuy () {
		  if (this.detailInfo.goods_storage > 0 && this.detailInfo.goods_state == 1 && this.detailInfo.goods_verify == 1) {
			  return true
		  } else {
			  return false
		  }
	  },
    cartNumber () {
    	let cartNumber = 0
    	if (this.shopCart.goods) {
    		this.shopCart.goods.forEach(food => {
    			cartNumber += food.goods_num
    		})
    	}
      if (cartNumber > 0 && cartNumber < 100) {
        return cartNumber
      } else if (cartNumber >= 100) {
        return '99+'
      }
    }
  },

  created () {
    this.$on('start-addcart-animation', () => {
      this.isAnimation = true
    })
    this.$on('end-addcart-animation', () => {
      this.isAnimation = false
      this.saveCartState(false)
    })
	  // this.getCartCount()
	  // this.$on('update-cart-num', () => {
		 //  this.getCartCount()
	  // })
  },

  methods: {
    ...mapMutations({
      saveCartState: 'saveCartState',
      changeType: 'changeType',
      saveSelectedCartGoods: 'saveSelectedCartGoods'
    }),
	  // getCartCount () {
		 //  cartQuantity().then(res => {
			//   if (res) {
			// 	  this.cartNumber = res.result.cart_count
			//   }
		 //  })
	  // },
    // 加入购物车
    addShopping (value) {
      this.saveCartState(value)
      this.changeType(this.$t('general.enter'))
    },

		// 立即购买
		// checkout () {
		// if (!this.canBuy) {
		// 	return
		// }
		// if (this.specList && Object.keys(this.specList).length>1) {
		// 	this.addShopping(true)
		// 	return
		// }
		// if (this.user) {
		// 	if (this.user.store_id == this.storeInfo.store_id) {
		// 		Toast(this.$t('store.alerts.cannot_buy_your_own'))
		// 		return
		// 	}
		// } else {
		// 	this.$router.push({ name: 'HomeMemberLogin' })
		// 	return
		// }
		// 	this.$router.push({ name: 'MemberBuyStep1', query: { buy_now: 1, cart_id: this.detailInfo.goods_id + '|1' } })
		// },

		// 购物车
		// goCart () {
		// 	if (this.isOnline) {
		// 		this.$router.push({ name: 'HomeCart', params: { type: 0 } })
		// 	} else {
		// 		this.$router.push({ name: 'HomeMemberLogin' })
		// 	}
		// },

		/*
		 * fromatArray: 格式化数组
		 */
		// fromatArray (delimiter, arrays) {
		// 	let data = ''
		// 	if (delimiter) {
		// 		data = arrays.join(delimiter)
		// 	}
		// 	return delimiter ? data : arrays
		// },

		/*
		 * isHasStock: 是否还有库存
		 */
		// isHasStock (id) {
		// 	let data = this.detailInfo.stock
		// 	if (data.length > 0) {
		// 		for (let i = 0, len = data.length; i <= len - 1; i++) {
		// 			if (data[i].goods_attr == id) {
		// 				return '' + data[i].stock_number + ''
		// 			}
		// 		}
		// 	}
		// }
	}
}
</script>

<style lang="scss" scoped>
.cartBox {
	width: 3.5rem;
    margin: 0px 1rem 0.8rem;
    background: white;
    border-radius: 50%;
    height: 3.5rem;
    display: flex;
    justify-content: center;
    break-after: ce;
    align-items: center;
    border: 4px solid #f4c41e;
}
.ui-detail-footer {
	background: #f4c41e;
	border-top: 1px solid #e8eaed;
	width: auto;
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 0;
	&.hidden-cart-footer {
		display: none;
	}

	&.show-cart-footer {
		display: block;
	}

	.footer-flex {
		display: flex;
		justify-content: space-between;
		align-content: center;
		align-items: center;
		height: 3rem;
	}
	p.good-stock-none {
		width: 100%;
		height: 1.6rem;
		background: #c3c3c3;
		opacity: 0.5;
		font-size: 0.7rem;
		color: #333333;
		line-height: 1rem;
		position: absolute;
		text-align: center;
		line-height: 1.6rem;
		padding: 0;
		margin: 0;
		bottom: 3rem;
	}
	div.left {
		display: flex;
		justify-content: center;
		align-items: center;
		.iconfont {
			width: 1.5rem;
			height: 1.5rem;
			flex-shrink: 0;
			margin: 0.35rem 1.75rem;
			font-size:1.5rem;
		}
		span.icon {
			position: absolute;
			left: 3.7rem;
    		top: -1rem;
			font-size: 0.5rem;
			line-height: 0.7rem;
			width: 0.9rem;
			height: 0.9rem;
			background: #ef3338;
			border-radius: 1rem;
			text-align: center;
			color: #ffffff;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	div.right {
		flex: 1;
		align-items: center;
		padding-right:$pageSpace;
		.right-wrapper{
			display: flex;
			flex-direction: row;
			border-radius:2rem;
			overflow: hidden;
		}
		.button {
			flex: 1;
			height: 2rem;
			font-size: 0.8rem;
			color: #ffffff;
			text-align: center;
			line-height: 2rem;
			cursor: pointer;
		}
		.disabled-cart {
			background: #c3c3c3;
		}
		.active-cart {
			background: #DD2C35;
		}
		.disabled-buy {
			background: #999999;
		}
		.active-buy {
			background: #FB2630;
		}
	}
}
.ui-cart-animation {
	position: fixed;
	top: 50%;
	left: 50%;
}
</style>
